import { theme } from '@dojo/framework/core/mixins/Themed';
import { v, w } from '@dojo/framework/core/vdom';
import { DNode } from '@dojo/framework/core/interfaces';
import { formatAriaProperties } from '@dojo/widgets/common/util';

import Button from '@dojo/widgets/button';
import MCQuestionBase from './mc-base';

import css from '../css/definition.m.css';

@theme(css)
export class Definition extends MCQuestionBase {
	protected render_front(): DNode {
		const { question } = this.properties;
		const { feedback } = question;

		return v('div', { key: 'card-front', xqa: 'flashcard front', classes: [this.theme(css.front)] }, [
			v('div', { key: 'definition', classes: [this.theme(css.cardDefinition)], innerHTML: feedback })
		]);
	}

	protected render_back(): DNode {
		const {
			question: { text, feedback }
		} = this.properties;

		return v('div', { key: 'card-back', xqa: 'flashcard back', classes: [this.theme(css.back)] }, [
			v('h2', { key: 'term', classes: [this.theme(css.cardTerm)], innerHTML: text }),
			v('div', { key: 'definition', classes: [this.theme(css.cardDefinition)], innerHTML: feedback })
		]);
	}

	protected buttons(): DNode {
		const { messages } = this.properties.localizedBundle;
		const flipText = messages['flip_card'] || '';
		const finishText = messages['finish'] || '';
		const nextText = messages['next_card'] || '';
		const { question, onNextQuestion, onFinish } = this.properties;
		const { status } = question;
		const islast = question.cursor + 1 === this.get_numberofquestions();

		return v('div', { key: 'card-action', classes: [this.theme(css.oneaction)] }, [
			status === 'question'
				? w(
						Button,
						{
							onClick: () => {
								question.status = 'feedback';
								this.update_result();
								this.invalidate();
							}
						},
						[flipText]
						// tslint:disable-next-line:indent
				  )
				: islast
				? w(
						Button,
						{
							onClick: () => {
								this.update_result().then(() => {
									onFinish();
								});
							}
						},
						[finishText]
						// tslint:disable-next-line:indent
				  )
				: w(
						Button,
						{
							onClick: () => {
								this.update_result();
								onNextQuestion();
							}
						},
						[nextText]
						// tslint:disable-next-line:indent
				  )
		]);
	}

	protected render(): DNode {
		const {
			question: { status }
		} = this.properties;
		const flipped = status !== 'question';

		return v('div', { classes: [this.theme(css.root)] }, [
			this.buttons(),
			v(
				'div',
				{
					classes: [this.theme(css.flipContainer), flipped ? this.theme(css.flipped) : null],
					...formatAriaProperties({ live: 'assertive' })
				},
				[v('div', { classes: [this.theme(css.flipper)] }, [flipped ? this.render_back() : this.render_front()])]
			)
		]);
	}
}
